// ---------------------------------------------
// auto-generated from primitives.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";

/*
 * EducaFinaz primitives — icons, charts, badges
 */

// ─── Icons (stroke 1.6, 20×20) ─────────────────────────────
export const Icon = ({ name, size = 18, stroke = 1.6, className = "", style }) => {
  const s = size;
  const sw = stroke;
  const props = {
    width: s, height: s, viewBox: "0 0 24 24",
    fill: "none", stroke: "currentColor", strokeWidth: sw,
    strokeLinecap: "round", strokeLinejoin: "round",
    className, style,
  };
  switch (name) {
    case "play": return <svg {...props}><path d="M7 5l12 7-12 7V5z" fill="currentColor" stroke="none"/></svg>;
    case "pause": return <svg {...props}><rect x="7" y="5" width="3.5" height="14" fill="currentColor" stroke="none"/><rect x="13.5" y="5" width="3.5" height="14" fill="currentColor" stroke="none"/></svg>;
    case "freeze": return <svg {...props}><path d="M12 3v18M3 12h18M5.5 5.5l13 13M18.5 5.5l-13 13"/></svg>;
    case "cc": return <svg {...props}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M9 11c-.5-.7-1.3-1-2-1s-2 .7-2 2.5S6.3 15 7 15s1.5-.3 2-1M16 11c-.5-.7-1.3-1-2-1s-2 .7-2 2.5 1.3 2.5 2 2.5 1.5-.3 2-1"/></svg>;
    case "spark": return <svg {...props}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/></svg>;
    case "book": return <svg {...props}><path d="M4 5a2 2 0 012-2h12v18H6a2 2 0 01-2-2V5z"/><path d="M4 17h14"/></svg>;
    case "headset": return <svg {...props}><path d="M4 14v-2a8 8 0 1116 0v2"/><rect x="3" y="14" width="4" height="6" rx="1.5"/><rect x="17" y="14" width="4" height="6" rx="1.5"/></svg>;
    case "movie": return <svg {...props}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 9h18M7 5v4M11 5v4M15 5v4M19 5v4"/></svg>;
    case "explore": return <svg {...props}><circle cx="12" cy="12" r="9"/><path d="M15 9l-2 5-5 2 2-5 5-2z" fill="currentColor" stroke="none"/></svg>;
    case "lightbulb": return <svg {...props}><path d="M9 18h6M10 21h4M12 3a6 6 0 00-3 11.2c.6.5 1 1.2 1 2v.8h4v-.8c0-.8.4-1.5 1-2A6 6 0 0012 3z"/></svg>;
    case "link": return <svg {...props}><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1"/></svg>;
    case "shield": return <svg {...props}><path d="M12 3l8 3v6c0 4.5-3.5 8-8 9-4.5-1-8-4.5-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/></svg>;
    case "help": return <svg {...props}><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5"/><circle cx="12" cy="17" r="0.5" fill="currentColor"/></svg>;
    case "check": return <svg {...props}><path d="M5 12l5 5L20 7"/></svg>;
    case "x": return <svg {...props}><path d="M6 6l12 12M18 6L6 18"/></svg>;
    case "retry": return <svg {...props}><path d="M4 12a8 8 0 0114-5.3M20 4v5h-5"/><path d="M20 12a8 8 0 01-14 5.3M4 20v-5h5"/></svg>;
    case "next": return <svg {...props}><path d="M5 12h14M13 6l6 6-6 6"/></svg>;
    case "back": return <svg {...props}><path d="M19 12H5M11 6l-6 6 6 6"/></svg>;
    case "save": return <svg {...props}><path d="M12 3l2.5 5 5.5.8-4 4 1 5.5L12 16l-5 2.3 1-5.5-4-4 5.5-.8L12 3z"/></svg>;
    case "share": return <svg {...props}><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="6" r="2.5"/><circle cx="18" cy="18" r="2.5"/><path d="M8 11l8-4M8 13l8 4"/></svg>;
    case "search": return <svg {...props}><circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/></svg>;
    case "graph": return <svg {...props}><circle cx="6" cy="6" r="2"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="12" r="2"/><circle cx="18" cy="20" r="1.5"/><path d="M7.5 7l9 4M7.5 17l9-4M18 14v4"/></svg>;
    case "map": return <svg {...props}><path d="M3 7l6-3 6 3 6-3v15l-6 3-6-3-6 3V7z"/><path d="M9 4v15M15 7v15"/></svg>;
    case "today": return <svg {...props}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18M8 3v4M16 3v4"/><rect x="7" y="13" width="4" height="4" rx="1" fill="currentColor" stroke="none"/></svg>;
    case "review": return <svg {...props}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>;
    case "profile": return <svg {...props}><circle cx="12" cy="9" r="4"/><path d="M4 21c1-4 4.5-6 8-6s7 2 8 6"/></svg>;
    case "draw": return <svg {...props}><path d="M3 21l4-1 11-11-3-3L4 17l-1 4z"/></svg>;
    case "compare": return <svg {...props}><rect x="3" y="6" width="8" height="12" rx="1.5"/><rect x="13" y="6" width="8" height="12" rx="1.6"/><path d="M12 4v16"/></svg>;
    case "tag": return <svg {...props}><path d="M3 11l8-8h8v8l-8 8-8-8z"/><circle cx="15" cy="9" r="1.4" fill="currentColor"/></svg>;
    case "ind": return <svg {...props}><path d="M4 18l4-6 4 3 4-8 4 5"/></svg>;
    case "vol": return <svg {...props}><path d="M4 20V12M9 20V8M14 20v-6M19 20V4"/></svg>;
    case "list": return <svg {...props}><path d="M4 6h16M4 12h16M4 18h10"/></svg>;
    case "lock": return <svg {...props}><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>;
    case "circle": return <svg {...props}><circle cx="12" cy="12" r="9"/></svg>;
    case "circle-dot": return <svg {...props}><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>;
    case "circle-check": return <svg {...props}><circle cx="12" cy="12" r="9" fill="currentColor" stroke="none"/><path d="M8 12l3 3 5-6" stroke="#06241f"/></svg>;
    case "diamond": return <svg {...props}><path d="M12 3l9 9-9 9-9-9 9-9z"/></svg>;
    case "stack": return <svg {...props}><path d="M4 8l8-4 8 4-8 4-8-4z"/><path d="M4 12l8 4 8-4M4 16l8 4 8-4"/></svg>;
    case "send": return <svg {...props}><path d="M4 12l16-7-7 16-2-7-7-2z"/></svg>;
    case "mic": return <svg {...props}><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0014 0M12 18v3"/></svg>;
    case "audio-wave": return <svg {...props}><path d="M3 12h2M7 8v8M11 5v14M15 8v8M19 12h2"/></svg>;
    case "down": return <svg {...props}><path d="M6 9l6 6 6-6"/></svg>;
    case "up": return <svg {...props}><path d="M6 15l6-6 6 6"/></svg>;
    case "more": return <svg {...props}><circle cx="6" cy="12" r="1.4" fill="currentColor"/><circle cx="12" cy="12" r="1.4" fill="currentColor"/><circle cx="18" cy="12" r="1.4" fill="currentColor"/></svg>;
    case "snowflake": return <svg {...props}><path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19"/><path d="M9 4l3 2 3-2M9 20l3-2 3 2M4 9l2 3-2 3M20 9l-2 3 2 3"/></svg>;
    case "target": return <svg {...props}><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></svg>;
    case "wifi-off": return <svg {...props}><path d="M2 2l20 20M5 12.5a10 10 0 015.5-2.9M19 12.5a10 10 0 00-3-2.2M8.5 16a5 5 0 017 0"/><circle cx="12" cy="20" r="0.8" fill="currentColor"/></svg>;
    case "globe": return <svg {...props}><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18"/></svg>;
    default: return null;
  }
};

// ─── FreshnessBadge / NotAdvice / SourceChip ───────────────
export const Eyebrow = ({ children }) => (
  <div className="mono" style={{
    fontSize: 10.5, letterSpacing: "0.12em", textTransform: "uppercase",
    color: "var(--text-3)"
  }}>{children}</div>
);

export const ObjectiveBar = ({ eye, children }) => (
  <div className="objective-bar">
    <div>
      <div className="eye">{eye}</div>
      <div className="text">{children}</div>
    </div>
  </div>
);

export const SourceRail = ({ source = "vendor_primary", time = "14:32 UTC", note = "Educativo · no es asesoramiento", live = true }) => (
  <div className="source-rail">
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 6, height: 6, borderRadius: 99, background: live ? "var(--accent)" : "var(--text-3)", boxShadow: live ? "0 0 8px var(--accent)" : "none" }}></span>
      <span>{live ? "LIVE" : "STATIC"}</span>
    </span>
    <span className="sep"></span>
    <span style={{ color: "var(--text-2)" }}>{source}</span>
    <span className="sep"></span>
    <span>{time}</span>
    <span style={{ marginLeft: "auto", color: "var(--text-3)" }}>{note}</span>
  </div>
);

export const Chip = ({ children, variant = "default", className = "", style }) => (
  <span className={`chip ${variant === "neutral" ? "neutral" : variant === "live" ? "live" : variant === "warn" ? "warn" : variant === "danger" ? "danger" : ""} ${className}`} style={style}>{children}</span>
);

// ─── Mini status bar (iOS-ish) ─────────────────────────────
export const StatusBar = ({ time = "9:41", dark = true }) => (
  <div style={{
    height: 44, display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "0 22px", fontFamily: "var(--t-sans)", fontWeight: 600,
    fontSize: 14, color: "var(--text)",
    position: "relative", zIndex: 5,
  }}>
    <span>{time}</span>
    <div style={{ display: "flex", gap: 6, alignItems: "center", opacity: 0.85 }}>
      <svg width="16" height="10" viewBox="0 0 16 10" fill="currentColor"><path d="M1 9V6h2v3H1zm4 0V4h2v5H5zm4 0V2h2v7H9zm4 0V0h2v9h-2z"/></svg>
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" strokeWidth="1.2"><path d="M1 5a8 8 0 0112 0"/><path d="M3.5 7a5 5 0 017 0"/><circle cx="7" cy="9" r="0.7" fill="currentColor"/></svg>
      <svg width="22" height="10" viewBox="0 0 22 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="18" height="9" rx="2"/><rect x="2" y="2" width="13" height="6" rx="0.8" fill="currentColor"/><rect x="19.5" y="3.5" width="1.6" height="3" rx="0.4" fill="currentColor"/></svg>
    </div>
  </div>
);

// ─── Candlestick chart (deterministic) ─────────────────────
export function genCandles(n = 60, seed = 7, opts = {}) {
  const { trend = 0.18, vol = 1.2, base = 100 } = opts;
  let x = base;
  let s = seed * 9301 + 49297;
  const rnd = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  const arr = [];
  for (let i = 0; i < n; i++) {
    const drift = trend * Math.sin(i / (n * 0.4)) + (rnd() - 0.5) * vol;
    const o = x;
    x += drift;
    const c = x;
    const hi = Math.max(o, c) + rnd() * vol * 0.8;
    const lo = Math.min(o, c) - rnd() * vol * 0.8;
    arr.push({ o, h: hi, l: lo, c, v: 0.4 + rnd() });
  }
  return arr;
}

export const Candles = ({
  data, width = 320, height = 180, padding = 6,
  showVolume = false, color = { up: "#5fd6c1", down: "#ff7a8c", wick: "#86a3d9" },
  overlays = [], // [{type:'zone', from:y, to:y, color:'accent'} | {type:'line', y, dashed} | {type:'marker', x, label} | {type:'label', x, y, text, color}]
  yPad = 0.04,
  className = "", style,
}) => {
  if (!data) return null;
  const min = Math.min(...data.map(d => d.l));
  const max = Math.max(...data.map(d => d.h));
  const span = max - min || 1;
  const yPx = (price) => padding + (1 - (price - min) / span) * (height - padding * 2 - (showVolume ? 28 : 0));
  const w = (width - padding * 2) / data.length;
  const bodyW = Math.max(2, w - 1.5);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={className} style={style}>
      <defs>
        <linearGradient id="gridFade" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(168,185,217,0.12)"/>
          <stop offset="100%" stopColor="rgba(168,185,217,0.0)"/>
        </linearGradient>
      </defs>
      {/* horizontal grid */}
      {[0.2, 0.4, 0.6, 0.8].map((p, i) => (
        <line key={i} x1={padding} x2={width - padding} y1={padding + p * (height - padding * 2 - (showVolume ? 28 : 0))}
              y2={padding + p * (height - padding * 2 - (showVolume ? 28 : 0))}
              stroke="rgba(168,185,217,0.06)" strokeWidth="1"/>
      ))}
      {/* zones */}
      {overlays.filter(o => o.type === "zone").map((o, i) => {
        const yA = yPx(o.to);
        const yB = yPx(o.from);
        const col = o.color === "accent" ? "rgba(95,214,193,0.18)" : o.color === "primary" ? "rgba(127,182,255,0.18)" : o.color || "rgba(127,182,255,0.18)";
        const stroke = o.color === "accent" ? "rgba(95,214,193,0.5)" : "rgba(127,182,255,0.5)";
        return (
          <g key={`z${i}`}>
            <rect x={padding} y={yA} width={width - padding * 2} height={Math.max(2, yB - yA)} fill={col}/>
            <line x1={padding} x2={width - padding} y1={yA} y2={yA} stroke={stroke} strokeDasharray="2 3" strokeWidth="1"/>
            <line x1={padding} x2={width - padding} y1={yB} y2={yB} stroke={stroke} strokeDasharray="2 3" strokeWidth="1"/>
            {o.label && (
              <text x={width - padding - 4} y={yA - 4} textAnchor="end" fontFamily="var(--t-mono)" fontSize="9" fill={stroke}>{o.label}</text>
            )}
          </g>
        );
      })}
      {/* horizontal lines */}
      {overlays.filter(o => o.type === "line").map((o, i) => (
        <line key={`l${i}`} x1={padding} x2={width - padding} y1={yPx(o.y)} y2={yPx(o.y)}
              stroke={o.color || "rgba(127,182,255,0.7)"} strokeWidth={o.strokeWidth || 1} strokeDasharray={o.dashed ? "3 3" : "0"}/>
      ))}
      {/* candles */}
      {data.map((d, i) => {
        const x = padding + i * w + (w - bodyW) / 2;
        const cx = padding + i * w + w / 2;
        const up = d.c >= d.o;
        const cFill = up ? color.up : color.down;
        const y0 = yPx(Math.max(d.o, d.c));
        const y1 = yPx(Math.min(d.o, d.c));
        return (
          <g key={i}>
            <line className="candle" x1={cx} x2={cx} y1={yPx(d.h)} y2={yPx(d.l)} stroke={color.wick} strokeOpacity="0.6" strokeWidth="1"/>
            <rect x={x} y={y0} width={bodyW} height={Math.max(1, y1 - y0)} fill={cFill} opacity="0.95" rx="0.5"/>
          </g>
        );
      })}
      {/* markers */}
      {overlays.filter(o => o.type === "marker").map((o, i) => {
        const cx = padding + o.x * w + w / 2;
        const y = yPx(o.y);
        return (
          <g key={`m${i}`}>
            <circle cx={cx} cy={y} r="6" fill="rgba(127,182,255,0.18)"/>
            <circle cx={cx} cy={y} r="3" fill="var(--primary)"/>
            {o.label && (
              <g>
                <rect x={cx + 8} y={y - 8} width={o.label.length * 5.5 + 8} height="14" rx="3"
                      fill="rgba(6,15,34,0.85)" stroke="rgba(127,182,255,0.35)"/>
                <text x={cx + 12} y={y + 2.5} fontFamily="var(--t-mono)" fontSize="9" fill="var(--primary)">{o.label}</text>
              </g>
            )}
          </g>
        );
      })}
      {/* labels (HH/HL etc) */}
      {overlays.filter(o => o.type === "swing").map((o, i) => {
        const cx = padding + o.x * w + w / 2;
        const y = yPx(o.y);
        const colors = {
          HH: "var(--accent)", HL: "var(--accent)",
          LH: "var(--negative)", LL: "var(--negative)",
        };
        const c = colors[o.label] || "var(--primary)";
        const above = o.label.startsWith("L");
        return (
          <g key={`s${i}`}>
            <circle cx={cx} cy={y} r="3" fill={c}/>
            <g transform={`translate(${cx + 6}, ${above ? y + 8 : y - 14})`}>
              <rect width="22" height="13" rx="3" fill="rgba(6,15,34,0.7)" stroke={c} strokeOpacity="0.5"/>
              <text x="11" y="9.5" textAnchor="middle" fontFamily="var(--t-mono)" fontSize="8.5" fill={c}>{o.label}</text>
            </g>
          </g>
        );
      })}
      {/* volume bars */}
      {showVolume && data.map((d, i) => {
        const x = padding + i * w + (w - bodyW) / 2;
        const baseY = height - padding;
        const h = d.v * 22;
        return <rect key={`v${i}`} x={x} y={baseY - h} width={bodyW} height={h} fill={d.c >= d.o ? "rgba(95,214,193,0.45)" : "rgba(255,122,140,0.45)"}/>;
      })}
    </svg>
  );
};

// ─── Section starter ───────────────────────────────────────
export const NotAdvice = ({ children = "Educativo · No es asesoramiento" }) => (
  <span className="mono" style={{
    fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--text-3)"
  }}>{children}</span>
);

// expose to window
